import { useState, useEffect } from "react";
import { ModalApontamentosDp, ContainerTableApontamentosDp, ContainerTableAdp, ContainerControllers, ItemBtnExport, ContainerBusca } from "./styled";
import { ContainerSearch, ComponentTitle } from "../styledGlobalModal";
import axios from "axios";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Switch, Select, Skeleton, DatePicker, ConfigProvider, Space } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { SearchOutlined, EditOutlined, LogoutOutlined } from '@ant-design/icons';
import { CiSearch, CiLogout, CiEdit } from "react-icons/ci";
import listTables from "./tableTitles.json"
import {
    TableContainer,
    TableBody,
    TableRow,
    TableColumn,
    TableHeader,
    ColumnTitle,
    TableTitle,
    TableHead,
} from "../../../../CSSGlobal";
import { BtnBlue, } from "../../Modal/styledGlobalModal";
import { PaginationBtn } from "../../../../styledEvents";
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import dayjs from 'dayjs';
import ModalTratamentoDp from "./ModalTratamentoDp";
// import ModalTratamento from "./ModalTratamento";


export function ApontamentosDp() {

    const [exporting, setExporting] = useState(false);
    const [isExcelAvailable, setIsExcelAvailable] = useState(true);
    const [clientParam, setClientParam] = useState("");
    const [titleTable, setTitleTable] = useState(listTables);
    const [showPendentes, setShowPendentes] = useState(true);
    const [pagePendentes, setPagePendentes] = useState(1);
    const [pageEmitidas, setPageEmitidas] = useState(1);
    const [totalPagesPendentes, setTotalPagesPendentes] = useState(0);
    const [totalPagesEmitidas, setTotalPagesEmitidas] = useState(0);
    const Numberpage = 5;
    const [listTableTarefasPendentes, setListTableTarefasPendentes] = useState([]);
    const [listTableTarefasEmitidas, setListTableTarefasEmitidas] = useState([]);

    const [showMessagePendentes, setShowMessagePendentes] = useState(false);
    const [showMessageEmitir, setShowMessageEmitir] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const [loadingPendentes, setLoadingPendentes] = useState(false);
    const [loadingEmitidas, setLoadingEmitidas] = useState(false);
    const [isExportDisabled, setIsExportDisabled] = useState(true);
    const [reportType, setReportType] = useState("");
    const [atendimentoId, setAtendimentoId] = useState("");
    const [isModalTratamento, setIsModalTratamento] = useState(false);
    const [toastsDisplayed, setToastsDisplayed] = useState(new Set());

    const [showTableTitle, setShowTableTitle] = useState(false);


    const monthFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    const maskFormat = 'YYYY-MM';
    const [date, setDate] = useState(dayjs().format(monthFormat));

    const toastId = {
        successPendentes: 'successPendentes',
        successEmitidas: 'successEmitidas',
        error: 'error'
    };

    useEffect(() => {
        setDate(dayjs().format(monthFormat));
    }, []);

    useEffect(() => {
        let height = 1000;
        window.parent.postMessage({ frameHeight: height }, "*");
      },);

    const fetchData = async () => {
        const url = "/portal/rest/contador/recurso/apontamento/pesquisar";
        const dataPendentes = {
            apontamento: {
                dataReferencia: date,
                situacao: {
                    id: "P"
                },
                recurso: {
                    nome: clientParam || null
                }
            },
            paginacao: { pagina: pagePendentes, tamanho: 5 }
        };
        const dataEmitidas = {
            apontamento: {
                dataReferencia: date,
                situacao: {
                    id: "F"
                },
                recurso: {
                    nome: clientParam || null
                }
            },
            paginacao: { pagina: pageEmitidas, tamanho: 5 }
        };

        setLoadingPendentes(true);
        setLoadingEmitidas(true);

        try {
            const [pendentesResponse, emitidasResponse] = await Promise.all([
                axios.post(url, dataPendentes, { withCredentials: true }),
                axios.post(url, dataEmitidas, { withCredentials: true })
            ]);

            if (Array.isArray(pendentesResponse.data.apontamentos)) {
                console.log("Apontamentos dp:", pendentesResponse.data.apontamentos)
                setListTableTarefasPendentes(pendentesResponse.data.apontamentos);
                setTotalPagesPendentes(pendentesResponse.data.paginacao.totalPaginas);
                setShowMessagePendentes(pendentesResponse.data.apontamentos.length === 0);

            }
            if (Array.isArray(emitidasResponse.data.apontamentos)) {
                setListTableTarefasEmitidas(emitidasResponse.data.apontamentos);
                setTotalPagesEmitidas(emitidasResponse.data.paginacao.totalPaginas);
                setShowMessageEmitir(emitidasResponse.data.apontamentos.length === 0);
            }

        } catch (error) {
            if (!toastsDisplayed.has(toastId.error)) {
                toast.error("Erro ao buscar os dados.");
                setToastsDisplayed(prev => new Set(prev).add(toastId.error));
            }
        } finally {
            setLoadingPendentes(false);
            setLoadingEmitidas(false);
        }
    };


    const exportToExcel = async (value) => {
        const excelUrl = `/portal/rest/contador/recurso/apontamento/export/excel?report=${value}&termo=${clientParam}&dataReferencia=${date}`;

        try {
            setExporting(true);
            const response = await axios.get(excelUrl, {
                withCredentials: true,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            let fileName = "";

            switch (value) {
                case "0":
                    fileName = 'planilha-controle-apontamentos.xlsx';
                    break;
                case "2":
                    fileName = 'apontamentos-detalhado.xlsx';
                    break;
            }

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Erro ao exportar os dados:', error);
            toast.error('Erro ao exportar os dados, tente novamente em poucos minutos.');
        } finally {
            setExporting(false);
        }
    };

    const changeClientParam = (e) => {
        setClientParam(e.target.value);
        setInitialLoad(true);

    }

    const handleData = () => {
        fetchData();
        setShowTableTitle(true);
        setInitialLoad(true);
        setIsExportDisabled(false);
    }

    const handleToggleChange = (checked) => {
        setShowPendentes(!checked);
        setPageEmitidas(1);
        setPagePendentes(1);
        // setSearchTerm("");
    };

    const handleChangePagePendentes = (event, newPage) => {
        setPagePendentes(newPage);
    };

    const handleChangePageEmitidas = (event, newPage) => {
        setPageEmitidas(newPage);
    };

    const handleChange = (value) => {
        setReportType(value);
        exportToExcel(value);
    };

    const handleModalTratamento = (id) => {
        setIsModalTratamento(!isModalTratamento);
        setAtendimentoId(id);
    }

    const onChangeValueDate = (dateValue, dateString) => {
        const formatDate = `${dateString}-15T00:00:00.000Z`;
        setDate(formatDate);
    };

    return (
        <ModalApontamentosDp>
            <ContainerTableApontamentosDp>
                <ContainerTableAdp>
                    <ContainerSearch>
                        <ContainerControllers>
                            <ComponentTitle>
                                <span>{"Apontamentos DP"}</span>
                            </ComponentTitle>
                            {isExcelAvailable && (
                                <ItemBtnExport>
                                    {!exporting && (
                                        <>
                                            <div className="select-export">
                                                <Select
                                                    defaultValue="Exportar Excel"
                                                    style={{ width: 220, textAlign: "center" }}
                                                    onChange={handleChange}
                                                    className="select-excel"
                                                >
                                                    <Select.Option value="0">Excel - Controle Apontamentos</Select.Option>
                                                    <Select.Option value="2" disabled={isExportDisabled}>
                                                        Excel - Apontementos Detalhados
                                                    </Select.Option>
                                                </Select>
                                            </div>
                                        </>
                                    )}
                                    {exporting && (
                                        <div>
                                            <CircularProgress
                                                className="cicleProgress"
                                                disableShrink
                                            />
                                        </div>
                                    )}
                                </ItemBtnExport>
                            )}
                        </ContainerControllers>
                    </ContainerSearch>
                    <ContainerBusca>
                        <Space direction="vertical">
                        <ConfigProvider locale={ptBR}>
                        <DatePicker
                                className="input-id"
                                defaultValue={dayjs(date, maskFormat)}
                                format={maskFormat}
                                picker="month"
                                style={{ width: "125px" }}
                                value={dayjs(date, maskFormat)}
                                onChange={onChangeValueDate}
                            />
                        </ConfigProvider>
                           
                        </Space>
                        <Input
                            placeholder="Cliente ID"
                            className="input-id"
                            value={clientParam}
                            onChange={changeClientParam}
                        />
                        <Button className="button-prox"
                            onClick={handleData}
                        >
                            <SearchOutlined />
                            Próximo
                        </Button>

                    </ContainerBusca>
                </ContainerTableAdp>
                {showTableTitle && (

                    <TableContainer>
                        <div className="checkbox-wrapper-34">
                            <Switch
                                checkedChildren="Emitidas"
                                unCheckedChildren="Pendentes"
                                defaultChecked
                                checked={!showPendentes}
                                onChange={handleToggleChange}
                            />
                        </div>

                        {showPendentes ? (
                            <>
                                {loadingPendentes ? (
                                    <Box sx={{ width: "100%" }}>
                                        <LinearProgress />
                                    </Box>
                                ) : null}
                                {loadingPendentes ? (
                                    <>
                                        {[...Array(2)].map((_, index) => (
                                            <Skeleton
                                                active
                                                key={index}
                                                variant="rectangular"
                                                width="100%"
                                                height={10}
                                                style={{ padding: "30px" }}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {showTableTitle && (
                                            <TableHeader>
                                                <TableHead>
                                                    {titleTable[0].titles.map((item, index) => {
                                                        return (
                                                            <ColumnTitle key={index} id={index}>
                                                                <TableTitle>
                                                                    <span>{item.title}</span>
                                                                </TableTitle>
                                                            </ColumnTitle>
                                                        );
                                                    })}
                                                </TableHead>
                                            </TableHeader>
                                        )}

                                        <TableContainer>
                                            <TableBody>
                                                <>
                                                    {listTableTarefasPendentes.map((item, index) => (
                                                        <>
                                                            <TableRow key={index}>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.cliente.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.cliente.carteira.id}/{item.recurso.cliente.equipe.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.dataReferencia}
                                                                    </span>
                                                                </TableColumn>

                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.tipo.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <Button className="button-prox" onClick={() => handleModalTratamento(item.id)} >
                                                                        <CiLogout className="icon-btn" />
                                                                        Tratar
                                                                    </Button>
                                                                </TableColumn>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </>
                                                {showMessagePendentes && (
                                                    <div className="msgFilterSearch">
                                                        <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                            <Alert severity="info">Nenhuma tarefa Pendente.</Alert>
                                                        </Stack>
                                                    </div>
                                                )}
                                            </TableBody>
                                            <PaginationBtn>
                                                <Stack spacing={1}>
                                                    <Pagination
                                                        count={Math.ceil(totalPagesPendentes / Numberpage)}
                                                        page={pagePendentes}
                                                        onChange={handleChangePagePendentes}
                                                        size="small"
                                                    />
                                                </Stack>
                                            </PaginationBtn>
                                        </TableContainer>
                                    </>
                                )}

                            </>
                        ) : (
                            <>
                                {loadingEmitidas ? (
                                    <Box sx={{ width: "100%" }}>
                                        <LinearProgress />
                                    </Box>
                                ) : null}
                                {loadingEmitidas ? (
                                    <>
                                        {[...Array(2)].map((_, index) => (
                                            <Skeleton
                                                active
                                                key={index}
                                                variant="rectangular"
                                                width="100%"
                                                height={10}
                                                style={{ padding: "30px" }}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <TableHeader>
                                            <TableHead>
                                                {titleTable[1].titles.map((item, index) => {
                                                    return (
                                                        <ColumnTitle key={index} id={index}>
                                                            <TableTitle>
                                                                <span>{item.title}</span>
                                                            </TableTitle>
                                                        </ColumnTitle>
                                                    );
                                                })}
                                            </TableHead>
                                        </TableHeader>
                                        <TableContainer>
                                            <TableBody>
                                                <>
                                                    {listTableTarefasEmitidas.map((item, index) => (
                                                        <>
                                                            <TableRow key={index}>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.cliente.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.cliente.carteira.id}/{item.recurso.cliente.equipe.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.dataReferencia}
                                                                    </span>
                                                                </TableColumn>

                                                                <TableColumn>
                                                                    <span>
                                                                        {item.recurso.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.tipo.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <Button className="button-prox" onClick={() => handleModalTratamento(item.id)}>
                                                                        <EditOutlined className="icon-btn" />
                                                                        Editar
                                                                    </Button>
                                                                </TableColumn>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </>
                                                {showMessageEmitir && (
                                                    <div className="msgFilterSearch">
                                                        <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                            <Alert severity="info">Nenhuma tarefa Emitida.</Alert>
                                                        </Stack>
                                                    </div>
                                                )}
                                            </TableBody>
                                            <PaginationBtn>
                                                <Stack spacing={1}>
                                                    <Pagination
                                                        count={Math.ceil(totalPagesEmitidas / Numberpage)}
                                                        page={pageEmitidas}
                                                        onChange={handleChangePageEmitidas}
                                                        size="small"
                                                    />
                                                </Stack>
                                            </PaginationBtn>
                                        </TableContainer>
                                    </>
                                )}

                            </>

                        )}
                    </TableContainer>
                )}
            </ContainerTableApontamentosDp>
            {isModalTratamento && (
                <ModalTratamentoDp
                    isOpen={isModalTratamento}
                    onClose={() => setIsModalTratamento(false)}
                    idClient={atendimentoId}
                    fetchPendentesData={fetchData}
                    fetchEmitidasData={fetchData}
                />
            )}
        </ModalApontamentosDp>
    );
}

export default ApontamentosDp;